import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

// Imports actions transverses
import DemandeCorrectionArticleSurPieceDialogContent from './Transverse/DemandeCorrectionArticleSurPieceDialogContent';
import DossierLieManuelDialogContent from './Transverse/DossierLieManuelDialogContent';

// Imports Transport
import RechercheColisSiteWebDialogContent from './Transport/RechercheColisSiteWebDialogContent';
import DemanderRelivraisonDialogContent from './Transport/DemanderRelivraisonDialogContent';
import DemanderImperatifDialogContent from './Transport/DemanderImperatifDialogContent';
import DemanderRechercheColisDialogContent from './Transport/DemanderRechercheColisDialogContent';
import RenvoiAvecFacturationDialogContent from './Transport/RenvoiAvecFacturationDialogContent';
import DemanderEnqueteChauffeurDialogContent from './Transport/DemanderEnqueteChauffeurDialogContent';
import PlainteLivraisonSauvageDialogContent from './Transport/PlainteLivraisonSauvageDialogContent';
import RenvoyerMarchandiseDialogContent from './Transport/RenvoyerMarchandiseDialogContent';
import FacturerTransporteurDialogContent from './Transport/FacturerTransporteurDialogContent';
import DemandeEnlevementDialogContent from './Transport/DemandeEnlevementDialogContent';
import DemandeEnlevementValideeDialogContent from './Transport/DemandeEnlevementValideeDialogContent';

import DemandeMiseEnDestructionDialogContent from './Transport/DemandeMiseEnDestructionDialogContent';
import OrdreEnlevementMatieresDangeureusesInflammablesDialogContent from './Transport/OrdreEnlevementMatieresDangeureusesInflammablesDialogContent';
import ReponseSouffranceTransporteurDialogContent from './Transport/ReponseSouffranceTransporteurDialogContent';


// Imports Qualité Entrepôt
import DemandeInformationsAcheteurDialogContent from './QualiteEntrepot/DemandeInformationsAcheteurDialogContent';
import ControlePoidsDialogContent from './QualiteEntrepot/ControlePoidsDialogContent';
import ControleStockDialogContent from './QualiteEntrepot/ControleStockDialogContent';
import RenvoiEnGratuitDialogContent from './QualiteEntrepot/RenvoiEnGratuitDialogContent';
import RenvoiEnPayantDialogContent from './QualiteEntrepot/RenvoiEnPayantDialogContent';
import AvoirClientDialogContent from './QualiteEntrepot/AvoirClientDialogContent';
import BLCorrectifDialogContent from './QualiteEntrepot/BLCorrectifDialogContent';
import DemanderRetourGeneralTousMagasinsContent from './QualiteEntrepot/DemanderRetourGeneralTousMagasinsContent';
import DemanderRegularisationStockMagasinContent from './QualiteEntrepot/DemanderRegularisationStockMagasinContent';
import DemanderControleStockMagasinContent from './QualiteEntrepot/DemanderControleStockMagasinContent';
import DemanderRetourDepuisUnMagasinContent from './QualiteEntrepot/DemanderRetourDepuisUnMagasinContent';


// Imports Magasin
import ProblemeQualiteProduitDialogContent from './Magasin/ProblemeQualiteProduitDialogContent';
import ProblemeTransportDialogContent from './Magasin/ProblemeTransportDialogContent';
import ErreurQuantiteDialogContent from './Magasin/ErreurQuantiteDialogContent';
import DeclarerInversionArticleDialogContent from './Magasin/DeclarerInversionArticleDialogContent';
import DeclarerRetourPlateformeDialogContent from './Magasin/DeclarerRetourPlateformeDialogContent';


// Imports Rapido
import RapidoRenvoiEnPayantDialogContent from './Rapido/RenvoiEnPayantDialogContent';

// Import ValidationDemandeEnlevement
import PrevenirClientRepriseMarchandiseDialogContent from './ValidationDemandeEnlevement/PrevenirClientRepriseMarchandiseDialogContent';

// Import ForceVente
import ForceVenteRetourFournisseurDialogContent from './ForceVente/RetourFournisseurDialogContent';


// Import SAV
import PretArticleDialogContent from './Sav/PretArticleDialogContent';
import EnvoiProduitFournisseurDialogContent from './Sav/EnvoiProduitFournisseurDialogContent';
import DemandeExpertiseDialogContent from './Sav/DemandeExpertiseDialogContent';
import GesteCommercialDialogContent from './Sav/GesteCommercialDialogContent';
import DemandeExpertiseFournisseurDialogContent from './Sav/DemandeExpertiseFournisseurDialogContent';
import RemplacementANeufDialogContent from './Sav/RemplacementANeufDialogContent';
import DemandePieceDetacheeFournisseurDialogContent from './Sav/DemandePieceDetacheeFournisseurDialogContent';
import DeclarerLitigeDialogContent from './Sav/DeclarerLitigeDialogContent';
import DeclarerMiseAuRebutProduitDialogContent from './Sav/DeclarerMiseAuRebutProduitDialogContent';
import AnnulationDialogContent from './Sav/AnnulationDialogContent';
import ReparationAdaptationSurPlaceDialogContent from './Sav/ReparationAdaptationSurPlaceDialogContent';
import DetailReparationDialogContent from './Sav/DetailReparationDialogContent';
import SavSaisiePieceGestionCommercialeContent from './Sav/SaisiePieceGestionCommercialeContent';
import SavManquantPackingListContent from './Sav/SavManquantPackingListContent';

// Import Relais litige
import DemanderClotureContent from './RelaisLitige/DemanderClotureContent';

// Import Réclamation sur bon de vente (RECENT)
import ReclamationSurBonDeVenteDialogContent from './ReclamationSurBonDeVente/ReclamationSurBonDeVenteDialogContent';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import { green } from '@mui/material/colors';

const styles = {
    formControl: {
        margin: 0,
        width: '100%'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }
};

const dialogContent = {
    'TRANSPORT_RECHERCHE_COLIS_SITE_WEB': RechercheColisSiteWebDialogContent,
    'TRANSPORT_DEMANDER_RELIVRAISON': DemanderRelivraisonDialogContent,
    'TRANSPORT_DEMANDER_IMPERATIF': DemanderImperatifDialogContent,
    'TRANSPORT_DEMANDER_RECHERCHE_COLIS': DemanderRechercheColisDialogContent,
    'TRANSPORT_RENVOI_AVEC_FACTURATION': RenvoiAvecFacturationDialogContent,
    'TRANSPORT_DEMANDER_ENQUETE_CHAUFFEUR': DemanderEnqueteChauffeurDialogContent,
    'TRANSPORT_PLAINTE_LIVRAISON_SAUVAGE': PlainteLivraisonSauvageDialogContent,
    'TRANSPORT_RENVOYER_MARCHANDISE': RenvoyerMarchandiseDialogContent,
    'TRANSPORT_FACTURE_TRANSPORTEUR': FacturerTransporteurDialogContent,
    'TRANSPORT_DEMANDE_ENLEVEMENT': DemandeEnlevementDialogContent,
    'TRANSPORT_DEMANDE_MISE_EN_DESTRUCTION': DemandeMiseEnDestructionDialogContent,
    'TRANSPORT_ORDRE_ENLEVEMENT_MATIERES_DANGEUREUSES_INFLAMMABLES': OrdreEnlevementMatieresDangeureusesInflammablesDialogContent,
    'TRANSPORT_REPONSE_SOUFFRANCE_TRANSPORTEUR': ReponseSouffranceTransporteurDialogContent,
    'TRANSPORT_DEMANDE_ENLEVEMENT_VALIDEE': DemandeEnlevementValideeDialogContent,

    'QUALITE_ENTREPOT_DEMANDE_INFORMATIONS': DemandeInformationsAcheteurDialogContent,
    'QUALITE_ENTREPOT_CONTROLE_POIDS': ControlePoidsDialogContent,
    'QUALITE_ENTREPOT_CONTROLE_STOCK': ControleStockDialogContent,
    'QUALITE_ENTREPOT_RENVOI_EN_GRATUIT': RenvoiEnGratuitDialogContent,
    'QUALITE_ENTREPOT_RENVOI_EN_PAYANT': RenvoiEnPayantDialogContent,
    'QUALITE_ENTREPOT_AVOIR_CLIENT': AvoirClientDialogContent,
    'QUALITE_ENTREPOT_BL_CORRECTIF': BLCorrectifDialogContent,
    'QUALITE_ENTREPOT_RETOUR_GENERAL_MAGASINS': DemanderRetourGeneralTousMagasinsContent,

    'QUALITE_ENTREPOT_DEMANDER_REGULARISATION_STOCK_MAGASIN': DemanderRegularisationStockMagasinContent,
    'QUALITE_ENTREPOT_DEMANDER_CONTROLE_STOCK_MAGASIN': DemanderControleStockMagasinContent,
    'QUALITE_ENTREPOT_DEMANDER_RETOUR_DEPUIS_UN_MAGASIN': DemanderRetourDepuisUnMagasinContent,

    'MAGASIN_PROBLEME_QUALITE_PRODUIT': ProblemeQualiteProduitDialogContent,
    'MAGASIN_PROBLEME_TRANSPORT': ProblemeTransportDialogContent,
    'MAGASIN_ERREUR_QUANTITE': ErreurQuantiteDialogContent,
    'MAGASIN_DECLARER_INVERSION_ARTICLE': DeclarerInversionArticleDialogContent,

    'MAGASIN_DECLARER_RETOUR_PLATEFORME': DeclarerRetourPlateformeDialogContent,

    'RAPIDO_RENVOI_EN_PAYANT': RapidoRenvoiEnPayantDialogContent,

    'PREVENIR_CLIENT_REPRISE_MARCHANDISE': PrevenirClientRepriseMarchandiseDialogContent,

    'FORCE_VENTE_RETOUR_FOURNISSEUR': ForceVenteRetourFournisseurDialogContent,


    'SAV_PRET_ARTICLE': PretArticleDialogContent,
    'SAV_ENVOI_PRODUIT_FOURNISSEUR': EnvoiProduitFournisseurDialogContent,
    'SAV_DEMANDE_EXPERTISE': DemandeExpertiseDialogContent,
    'SAV_GESTE_COMMERCIAL': GesteCommercialDialogContent,
    'SAV_DEMANDE_EXPERTISE_FOURNISSEUR': DemandeExpertiseFournisseurDialogContent,
    'SAV_REMPLACEMENT_A_NEUF': RemplacementANeufDialogContent,
    'SAV_DEMANDE_PIECE_DETACHEE_FOURNISSEUR': DemandePieceDetacheeFournisseurDialogContent,
    'SAV_DECLARER_LITIGE': DeclarerLitigeDialogContent,
    'SAV_DECLARER_MISE_AU_REBUT_PRODUIT': DeclarerMiseAuRebutProduitDialogContent,
    'SAV_ANNULATION': AnnulationDialogContent,
    'SAV_REPARATION_ADAPTATION_SUR_PLACE': ReparationAdaptationSurPlaceDialogContent,
    'SAV_DETAIL_REPARATION': DetailReparationDialogContent,
    'SAV_SAISIE_PIECE_GESTION_COMMERCIALE': SavSaisiePieceGestionCommercialeContent,
    'SAV_MANQUANT_PACKING_LIST': SavManquantPackingListContent,

    'RELAI_LITIGE_DEMANDE_CLOTURE': DemanderClotureContent,

    'GENERATION_RECENT': ReclamationSurBonDeVenteDialogContent,

    'DEMANDE_CORRECTION_ARTICLE_SUR_PIECE': DemandeCorrectionArticleSurPieceDialogContent,

    'DEMANDE_DOSSIER_LIE_MANUEL': DossierLieManuelDialogContent


};

class AddActionDialog extends React.Component {

    render() {
        const { classes, open, onClickCancel, onClickSave, onChange, reclamationId, action, sauvegardable, isAdding } = this.props;

        let DialogContent = dialogContent[action.code];

        return (
            <Dialog
                fullWidth
                maxWidth={'md'}
                classes={{ paper: classes.dialogPaper }}
                open={open}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onClose(event, reason)
                    }
                }}
            >
                <DialogTitle>
                    Dossier après-vente {reclamationId} : {action.libelle}
                </DialogTitle>

                <DialogContent onChange={onChange} action={action} reclamationId={reclamationId} isAdding={isAdding} />

                <DialogActions>
                    <Button disabled={isAdding} onClick={onClickCancel} color="primary" >Annuler</Button>
                    <Button
                        disabled={!sauvegardable || isAdding}
                        onClick={onClickSave}
                        variant="contained"
                        color="secondary"
                    >
                        Enregistrer
                        {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

AddActionDialog.propTypes = {
    onClickCancel: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    reclamationId: PropTypes.number.isRequired,
    action: PropTypes.object.isRequired,
    sauvegardable: PropTypes.bool.isRequired,
    isAdding: PropTypes.bool.isRequired
};

export default withStyles(styles)(AddActionDialog);